import React, { useState, useEffect } from 'react';

export const DIMENSIONS = getWindowDimensions();
export const WINDOW_WIDTH = DIMENSIONS.width;
export const WINDOW_HEIGHT = DIMENSIONS.height;

const guidelineBaseWidth = DIMENSIONS.width;

export const scaleSize = size => (WINDOW_WIDTH/guidelineBaseWidth) * size;

function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height
    };
  }
  
  export default function useWindowDimensions() {

    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
  
    useEffect(() => {
      function handleResize() {
        setWindowDimensions(getWindowDimensions());
      }
  
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);
  
    return windowDimensions;
  }